import { useEffect } from 'react'
import { usePurchasingNavStore } from '@/store/purchasingNavStore'

const POLL_INTERVAL_MS = 30_000

/** Keeps the Purchasing sidebar badge count fresh (unfiltered needs_review queue). */
export function usePurchasingNavPoller() {
  const fetchCount = usePurchasingNavStore((s) => s.fetchCount)

  useEffect(() => {
    void fetchCount()
  }, [fetchCount])

  useEffect(() => {
    const interval = setInterval(() => {
      void fetchCount()
    }, POLL_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [fetchCount])
}
